<template>
    <div class="st-switch">
        <div class="st-title">
            <span class="text-tt">{{ title }}</span>
        </div>
        <div class="st-content">
            <a-radio-group v-model="value"
                           @change="moduleChanged"
                           :disabled="confirmVisible"
            >
                <at-popover v-model="confirmVisible"
                            @cancel="moduleConfirm(0)"
                            @confirm="moduleConfirm(1)">
                    <div slot="text">
                        {{ tips }}
                    </div>
                    <span class="st-flag"></span>
                </at-popover>
                
                <template v-for="(item,lk) in options">
                    <a-radio :key="lk" :value="item.value">
                        <span class="radio-text">{{ item.label }}</span>
                    </a-radio>
                </template>
            
            </a-radio-group>
        </div>
    </div>
</template>
<script>
import AtPopover from "@/components/AtPopover.vue";

export default {
    components: {AtPopover},
    model: {
        prop: "originValue",
        event: "change"
    },
    props: {
        title: String,
        originValue: {
            type: [Number, String],
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        originValue: {
            handler(newVal) {
                this.$nextTick(() => {
                    this.value = newVal;
                })
            },
            immediate: true
        }
    },
    data() {
        return {
            configLoading: true,
            value: null,
            confirmVisible: false,
        }
    },
    computed:{
        tips() {
            let item = this.options.find((item) => item.value === this.value);
            return item ? item.tips : "";
        }
    },
    methods: {
        moduleConfirm(confirm) {
            this.confirmVisible = false
            
            let value = this.value;
            
            this.value = this.originValue;
            
            if (!confirm) return;
            
            this.$emit("change", value);
        },
        moduleChanged() {
            this.confirmVisible = true;
        }
    }
}
</script>

<style lang="scss" scoped>

.st-switch {
    display: flex;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
    align-items: center;
    
    .st-title {
        margin-right: 24px;
    }
    
    .st-content {
        position: relative;
    }
    
    .st-flag {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2px;
        height: 2px;
    }
}
</style>